import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Home } from './pages/Home';
import { ChristmasLights } from './pages/ChristmasLights';
import { ResidentialLighting } from './pages/ResidentialLighting';
import { CommercialLighting } from './pages/CommercialLighting';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rl6tv22wcks6">
      <ScrollToTop data-id="element-1" data-mp="2rikqzfqyatga" />
      <div className="min-h-screen w-full bg-white" data-id="element-2" data-mp="2mmce69087cca">
        <Header data-id="element-3" data-mp="2mnnfm2678808" />
        <Routes data-id="element-4" data-mp="2mjzo18kbdvo5">
          <Route path="/" element={<Home data-id="element-6" data-mp="31ayv2f5i4c5m" />} data-id="element-5" data-mp="31agnwnhawdix" />
          <Route path="/christmas-lights" element={<ChristmasLights data-id="element-8" data-mp="2wk08wyxu0jug" />} data-id="element-7" data-mp="31c9uy3vtszrg" />
          <Route path="/christmas-lights/residential" element={<ResidentialLighting data-id="element-10" data-mp="2whxd1y9zzwht" />} data-id="element-9" data-mp="2wjqft2hhpwkj" />
          <Route path="/christmas-lights/commercial" element={<CommercialLighting data-id="element-12" data-mp="28sl0cofgp6ar" />} data-id="element-11" data-mp="28tw3qn4zwc1c" />
          <Route path="*" element={<Home data-id="element-14" data-mp="23u9tmmkgrbwr" />} data-id="element-13" data-mp="23vkuadim43jn" />
        </Routes>
      </div>
    </BrowserRouter>;
}